<app-modal-filler-atom
  [index]="index + 10"
  (onClick)="closeModal($event)"
>
  <div class="flex h-full w-full items-end justify-center md:items-center">
    <div
      class="pointer-events-auto flex w-full flex-col gap-8 rounded-t-3xl bg-white p-5 md:w-auto md:rounded-3xl md:p-7"
    >
      <!-- Header -->
      <div class="flex flex-col gap-4">
        <div class="flex items-start justify-between gap-4">
          <!-- Title -->
          <div class="text-3xl font-bold">
            {{ title || ('user-feedback.min-value-label' | translate) }}
          </div>

          <!-- Close modal  button -->
          <app-rounded-icon-button
            size="sm"
            type="white"
            icon="icon-cross"
            (click)="closeModal($event)"
          ></app-rounded-icon-button>
        </div>

        <!-- Description -->
        <div class="text-lg">{{ description }}</div>
      </div>

      <!-- Content -->
      <app-block-list
        class="flex flex-col gap-4"
        [blockIdList]="items"
      ></app-block-list>
    </div>
  </div>
</app-modal-filler-atom>
